<template>
  <div>
    <div>
      <el-descriptions size="mini" :label-style="{width: '80px'}" :column="3" border>
        <el-descriptions-item label="房产">
<!--          <el-input-->
<!--            :value="mainObj.house_name"-->
<!--            style="width: 100%"-->
<!--            size="mini"-->
<!--            disabled-->
<!--          ></el-input>-->
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            size="mini"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            clearable
            placeholder="请输入房产"
            popper-class="autocomplete-room"
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="装修状态">
          <el-select
            v-model="where.status"
            size="mini"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in status_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">
          <el-row>
            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="where.apply_start_time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="2">
              至
            </el-col>
            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="where.apply_end_time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
          </el-row>
        </el-descriptions-item>
        <el-descriptions-item label="完工时间">
          <el-row>
            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="where.furnish_start_time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="2">
              至
            </el-col>
            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="where.furnish_end_time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
          </el-row>
        </el-descriptions-item>
        <el-descriptions-item label="操作">
          <el-button size="mini" type="primary" @click="add()">添加装修</el-button>
          <el-button size="mini" @click="showStudy()">操作指引</el-button>
          <el-button size="mini" @click="toFrom()">导出巡查记录报表</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border
        style="width: 100%">
        <el-table-column
          prop="ID"
          label="ID"
          width="90">
        </el-table-column>
        <el-table-column
          prop="FitmentID"
          label="装修编号"
          width="150">
          <template slot-scope="scope">
            <el-link type="primary" @click="edtiClik(scope.row)">{{scope.row.FitmentID?scope.row.FitmentID:'无编号'}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="house_name"
          label="房产" width="320"></el-table-column>
        <el-table-column
          prop="ApplyDate"
          label="申请时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="业主名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="ProcessState"
          label="装修状态"
          width="100">
          <template slot-scope="scope">
            {{getStatus(scope.row.ProcessState).name}}
          </template>
        </el-table-column>
        <el-table-column
          prop="TakeChargeName"
          label="责任人"
          width="100">
        </el-table-column>
        <el-table-column
          label="	操作"
          width="180">
<!--          <template slot-scope="scope">-->
<!--            &lt;!&ndash;          <el-button @click="handleClick(scope.row)" type="text" size="small">装修押金</el-button>&ndash;&gt;-->
<!--            <el-button v-if="scope.row.status == '已审批'" @click="cardIntoClik(scope.row)" type="primary" size="mini">出入证</el-button>-->
<!--            <el-button v-if="scope.row.status == '已审批'" @click="inspectionClik(scope.row)" type="success" size="mini">装修巡查</el-button>-->
<!--            <el-button @click="approvalClik(scope.row)" type="warning " size="mini">查看审批</el-button>-->
<!--            <el-dropdown @command="handleCommand" v-if="scope.row.status == '已审批'">-->
<!--              <el-button type="danger" size="mini">-->
<!--                更多<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--              </el-button>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item :command="{name:'printFurnish',id:scope.row.id,data:scope.row}">打印入场证</el-dropdown-item>-->
<!--                &lt;!&ndash;                <el-dropdown-item :command="{name:'CustomerFurnish',id:scope.row.id,data:scope.row}">编辑申请</el-dropdown-item>&ndash;&gt;-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
<!--          </template>-->
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>

    <ViewFile ref="ViewFile" />

  </div>
</template>

<script>
import FurnishEditor from "./FurnishEditor";
import ViewFile from "../../../../Common/ViewFile";
import AppConfig from "../../../../../../config/AppConfig";
export default {
  name: "FurnishList",
  components: {ViewFile, FurnishEditor},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      where:{
        status:0,
        apply_start_time:"",
        apply_end_time:"",
        furnish_start_time:"",
        furnish_end_time:"",
      },
      status_list:[
        { name: "未审批", value: 0 },
        { name: "审批中", value: 1 },
        { name: "已审批", value: 2 },
        { name: "已缴费", value: 3 },
        { name: "已入场", value: 4 },
        { name: "已取消", value: 5 },
        { name: "已完成", value: 6 },
      ],
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
    }
  },
  activated() {
    this.getList()
  },
  methods:{
    getList() {
      const that = this;
      if(!that.mainObj.house_name){
        return false;
      }
      that.loading = true;
      let where = ERP.reJson({
        ...that.where,
        ...that.mainObj
      })

      ERP.postRequest({
        url: "admin/HouseFurnish/getList",
        data: {
          ...where,
          page: that.pageData.page,
          page_size: that.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edtiClik(item){
      const that = this;
      that.mainObj.id=item.ID;
      that.mainObj.house_id=item.HouseID;
      that.mainObj.house_name=item.house_name;

      that.setComponentId("FurnishMain")
    },
    add() {
      const that = this;
      if(that.mainObj.house_id){
        that.mainObj.id="";
        that.setComponentId("FurnishMain");
      }else {
        that.$message.error('请选择房产再添加！');
      }
    },
    toFrom() {
      const that = this;
      // that.setComponentId("FurnishExcel");
      this.$router.push({ name: 'DecorationInspectionRecordForm' });
    },
    getStatus(val){
      return this.status_list.find(ret=>ret.value==val)||{}
    },
    showStudy(){
      const that=this;
      let file_url=AppConfig.erp_server+"/word_template/zhuang_xiu_guang_li_chao_zuo_zhi_yin.docx";
      that.$refs.ViewFile.show({
        width: '90vw',
        height:'80vh',
        title:"装修管理操作指引",
        src:file_url,
        download(){
          window.open(file_url)
        }
      })
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      this.mainObj.house_id=item.id;
      // this.mainObj.house_name=item.name;
      this.pageChange(1)
    }
  },
  watch:{
    "mainObj.house_name":function () {
      this.pageChange(1)
    },
    "where.status":function () {
      this.pageChange(1)
    },
    "where.apply_start_time":function () {
      this.pageChange(1)
    },
    "where.apply_end_time":function () {
      this.pageChange(1)
    },
    "where.furnish_start_time":function () {
      this.pageChange(1)
    },
    "where.furnish_end_time":function () {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishList.vue